// removed by extract-text-webpack-plugin
module.exports = {"title":"user-form__title-GFMSe","description":"user-form__description-2e4MK","buttonsBlock":"user-form__buttonsBlock-qoCd6","fieldset":"user-form__fieldset-1Sdl3","individual":"user-form__individual-1SNuV"};


//////////////////
// WEBPACK FOOTER
// ./components/common/user/user-form/user-form.css
// module id = 831
// module chunks = 0